import React from 'react'

type Props = {
  checkOption: string
  categoryId: number
  rolesState: [[], React.Dispatch<React.SetStateAction<[]>>]
}

export default function Role({ checkOption, rolesState, categoryId }: Props) {
  const [roleStateChecked, setRoleStateChecked] = rolesState

  const handleCheckedChange = (e: any) => {
    const key = e.target.value

    if (!(key in roleStateChecked) || !roleStateChecked[key]) {
      addRole(e.target.value)
    } else {
      removeRole(e.target.value)
    }
  }

  function removeRole(role: string) {
    // @ts-ignore
    setRoleStateChecked((preState) => ({ ...preState, [role]: false }))
  }
  function addRole(role: string) {
    // @ts-ignore
    setRoleStateChecked((preState) => ({ ...preState, [role]: true }))
  }

  return (
    <label
      htmlFor={'checkbox1' + categoryId}
      className={
        'flex w-full grow cursor-pointer select-none flex-row items-center justify-between bg-gray-0 px-4 py-3'
      }
    >
      <p className={'text-body-normal text-fizz-1000'}>{checkOption}</p>

      <input
        className='h-5 w-5 cursor-pointer border border-gray-70 bg-gray-0 text-fizz-1000 focus:ring-0 focus:ring-offset-0'
        type='checkbox'
        value={categoryId}
        id={'checkbox1' + categoryId}
        checked={roleStateChecked[categoryId] ?? false}
        onChange={handleCheckedChange}
      />
    </label>
  )
}
